<template>
  <!-- 第一層 -->
  <div class='topAll'>
    <el-row>
      <el-col :span="8" class="topLeft">
        <ul>
          <li><a href="http://newpreschool.com.tw/"><img src="@/assets/img/logo.png" alt="icon" class="img-opacity"></a></li>
          <li><a href="https://newpolo.com.tw/"><img src="@/assets/img/logo-1.png" alt="icon" class="img-opacity"></a></li>
          <li><a href="https://newcap.com.tw/"><img src="@/assets/img/logo-2.png" alt="icon" class="img-opacity"></a></li>
          <li><a href="https://newsuit.com.tw/"><img src="@/assets/img/logo-3.png" alt="icon" class="img-opacity"></a></li>
          <li><a href="http://newbag.com.tw/"><img src="@/assets/img/logo-4.png" alt="icon" class="img-active"></a></li>
        </ul>

      </el-col>
      <el-col :span="8" class="topCenter">
        <strong>Welcome to newred ! Join our members for more benefits.</strong>
      </el-col>
      <el-col :span="8" class="topRight">
        <ul>
          <li><a href="/"><i class="el-icon-user"></i>Sign in</a></li>
          <li><a href="/"><i class="el-icon-star-off"></i>Hearts</a></li>
          <li><a href="/"><i class="el-icon-box"></i>Orders</a></li>
        </ul>
      </el-col>
    </el-row>

  </div>
</template>

<script>

  export default {
    name: 'navTop'
  };

</script>
<style lang='scss' scoped>
  @import '~assets/scss/mixins';

  .topAll {
    width: 60%;
    height: 40px;
    line-height: 30px;
    margin: 0 auto;
    ul {
      display: flex;
      img {
        width: 40px;
      }
    }
    .topLeft {
      a {
        padding-right: 10px;
        .img-active {
          // border: 2px dashed $bgc-blue;
        }
        .img-opacity {
          opacity: 0.3;
        }
      }
    }
    .topCenter {
      text-align: center;
      line-height: 40px;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      strong {
        font-weight: bold;
        color: $bgc-blue;
      }
    }
    .topRight {
      ul {
        justify-content: flex-end;
        line-height: 40px;
        a {
          padding-left: 20px;
          i {
            font-size: 20px;
            padding-right: 3px;
          }
        }
      }
    }
  }
  @media screen and (min-width: 1920px){}
  @media (min-width:1366px) and (max-width:1920px){
    .topAll {
      width: 80%;
    }
  }
  @media (min-width:1024px) and (max-width:1365px){
    .topAll {
      width: 90%;
    }
  }
  @media screen and (max-width: 1023px){
    .topAll {
      width: 100%;
      .topLeft {
        width: 100%;
        background-color: #f7e8aa;
        ul {
          justify-content: center;
          align-items: center;
          height: 60px;
        }
      }
      .topCenter,.topRight {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navLine/index.vue